(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race/create-race-handler.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race/create-race-handler.js');
'use strict';

const {
  functional: {
    pipe
  }
} = svs.components.sport.raceHandler.common;
const {
  createRaceHandlerBase
} = svs.components.sport.raceHandler.race;
const {
  createJupiterInstance
} = svs.components.sport.raceHandler;
const jupiter = createJupiterInstance();
const createRaceHandler = () => function () {
  let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return publicInterface;
};
const privateInterface = {
  jupiter
};
const fns = [createRaceHandlerBase, createRaceHandler].map(fn => fn(privateInterface));
const raceHandlerCreator = pipe(...fns);
setGlobal('svs.components.sport.raceHandler.race.createRaceHandler', raceHandlerCreator);

 })(window);